import Deactivate from '@/apps/account/deactivation/Deactivate.vue';
import SorryToSeeYouGo from '@/apps/account/deactivation/SorryToSeeYouGo.vue';
import Questionnaire from '@/apps/account/deactivation/Questionnaire.vue';
import SitterSelect from '@/apps/account/deactivation/SitterSelect.vue';
import Survey from '@/apps/account/deactivation/Survey.vue';
import ConfirmDeactivation from '@/apps/account/deactivation/ConfirmDeactivation.vue';
import { requireSeeker } from '../guards/authGuards';
import setMetaTagsGuard from '../guards/metaTagsGuard';
import combineGuards from '../guards/helpers';

const deactivationRoutes = [
  // Confirmation route - accessible to non-logged-in users (MUST come first for specificity)
  {
    path: '/account/deactivation/confirmation',
    name: 'ConfirmDeactivation',
    component: ConfirmDeactivation,
    meta: {
      robots: 'noindex, nofollow',
    },
    beforeEnter(to, from, next) {
      setMetaTagsGuard(to, from, next);
    },
  },
  {
    path: '/account/deactivation',
    component: Deactivate,
    beforeEnter: combineGuards([requireSeeker]),
    children: [
      {
        path: '',
        name: 'SorryToSeeYouGo',
        component: SorryToSeeYouGo,
      },
      {
        path: 'mobile',
        name: 'Mobile',
        component: SorryToSeeYouGo,
        props: { isMobile: true },
      },
      {
        path: 'questionnaire',
        name: 'Questionnaire',
        component: Questionnaire,
      },
      {
        path: 'sitter-select',
        name: 'SitterSelect',
        component: SitterSelect,
      },
      {
        path: 'survey',
        name: 'Survey',
        component: Survey,
      },
      { path: '*', redirect: '/account/deactivation' },
    ],
  },
];

export default deactivationRoutes;
